<template>
  <div class="ml-3 mb-3">
    <div class="ml-2 mb-2">
      <span class="orange-icon orange-icon-badge-align fa fa-info-circle" />
      <strong class="py-2 pl-2 font-16">Documento de Contrato</strong>
    </div>
    <custom-callout
      v-if="infoFromApi.documentFilename"
      border-color-hex="#E2E2E2"
      class="ml-2 mt-5"
      :has-toggle="false"
    >
      <div class="ml-md-4 pl-md-2 mr-md-3 mt-md-2 mb-md-2">
        <div class="row p-md-2">
          <div class="col-md-3 col-sm-12">
            <span class="data-title d-block border-mobile">
              Tipo de Documento:
            </span>
            <span class="font-16 color-black">
              {{ infoFromApi.documentTypeName }}
            </span>
          </div>
          <div class="col-md-3 col-sm-12">
            <span class="data-title d-block border-mobile">
              Fecha:
            </span>
            <span class="font-16 color-black">
              {{ infoFromApi.lastModifyDate | datetime }}
            </span>
          </div>
          <div class="col-md-3 col-sm-12">
            <span class="data-title d-block border-mobile">Archivo:</span>
            <span class="font-16 color-black">
              {{ infoFromApi.documentFilename | empty }}
            </span>
          </div>
          <div class="col-md-3 col-sm-12 d-flex justify-content-end">
            <action-button
              id="actionBtnDownloadDocumentSigned"
              i="fas fa-file-download pl-2 mt-2 mb-2"
              variant="success mr-5 mt-2 mb-2 pr-2 pl-2"
              @click="downloadDocument"
            />
          </div>
        </div>
      </div>
    </custom-callout>
    <div v-else class="pb-3">
      <custom-result-not-found text="No cuenta con Documento." />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import CustomResultNotFound from 'custom-result-not-found';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import { getDocumentSigned } from '@/services/provider/billing-document.api';
import utils from '@/utils/utilities';
export default {
  name: 'DocumentContract',
  components: {
    ActionButton,
    CustomCallout,
    CustomResultNotFound,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      infoFromApi: {},
    };
  },
  async mounted() {
    let payload = {
      contractId: this.data.contractId,
    };

    await getDocumentSigned(payload.contractId).then((data) => {
      this.infoFromApi = data.data;
    });
  },
  computed: {},
  methods: {
    downloadDocument() {
      if (this.infoFromApi.content) {
        this.infoFromApi.filename = this.infoFromApi.documentFilename;
        this.infoFromApi.contentType = 'application/pdf';
        utils.convertToBlob(this.infoFromApi);
      } else {
        _downloadDocumentByAttachmentId(
          this.infoFromApi.documentAttachmentId
        ).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.container-info {
  position: relative;
  top: -15px;
}
.orange-icon {
  color: #ff7058;
}
</style>
